import LocalizedStrings from 'react-localization';

const english = {
    Action_Cancel: 'Cancel',
    Action_ClearFilters: 'Clear filters',
    Action_ClearSelected: 'Clear Selected',
    Action_Close: 'Close',
    Action_ClosePopup: 'Close Popup',
    Action_Delete: 'Delete',
    Action_Edit: 'Edit',
    Action_Export: 'Export Data',
    Action_ManageColumn: 'Manage Columns',
    Action_No: 'No',
    Action_Refresh: 'Refresh',
    Action_SaveSelected: 'Save Selected',
    Action_Update: 'Update',
    Action_View: 'View',
    Action_Yes: 'Yes',

    ClearSearch: 'Clear Search',
    Further_Options: 'Further Options',
    Manage_Columns: 'Manage Columns',

    Label_100_PerPage: '100 per page',
    Label_25_PerPage: '25 per page',
    Label_250_PerPage: '250 per page',
    Label_50_PerPage: '50 per page',
    Label_500_PerPage: '500 per page',
    Label_ClearSearch: 'Clear Search',
    Label_InfoMessage: 'Information Message',
    Label_Loading: 'Loading...',
    Label_MoreOptions: 'More Options',
    Label_Search: 'Search',
    Label_Select: 'Select...',

    Action_MoveToTheFirstPage: 'Move to the first page',
    Action_MoveToThePreviousPage: 'Move to the previous page',
    Action_MoveToTheNextPage: 'Move to the next page',
    Action_MoveToTheLastPage: 'Move to the last page',
    Action_ResetToDefault: 'Reset To Default',

    Message_UnknownError: `An unknown error has occurred, please refresh your browser`,

    // AG Grid
    Label_SituationResponseNotOK: 'Situation Response: Not Okay',
    Label_SituationResponseOK: 'Situation Response: Okay',

    // Search
    Search_Label_NoResultsFound: 'No Results Found',
    Search_Label_OneResultFound: '1 Result Found',
    Search_Label_MoreResultsFound: ' Results Found',

    // FilterBar
    FilterBar_Label_AddFilter: 'Add Filter',
    FilterBar_Label_EditFilter: 'Edit Filter',
    FilterBar_Label_FixedFilter: 'Fixed Filter cannot be removed',
    FilterBar_Label_RemoveFilter: 'Remove Filter',
    FilterBar_Label_IsMissing: '{0} is missing a value',
    FilterBar_Label_Is: 'is',
    FilterBar_Label_PlusMore: '+ More',
    FilterBar_Label_NotProvided: '(Not Provided)',

    VisitorBannedMarker_Label_VisitorBanned: 'Banned',
    VisitorHoldMarker_Label_VisitorHold: 'Visitor Hold',

    UploadAvatar_Action_AcceptButton: 'Crop Image',
    UploadAvatar_Action_TakePhoto: 'Take Photo',
    UploadAvatar_Action_UploadPhoto: 'Upload Photo',
    UploadAvatar_Action_UseCamera: 'Use Camera',
    UploadAvatar_Label_AltText: 'Uploaded File',
    UploadAvatar_Label_DragDrop1: 'Drag and drop or',
    UploadAvatar_Label_DragDrop2: 'upload from your computer',
    UploadAvatar_Label_DragToReposition: 'Drag to reposition',
    UploadAvatar_Label_HeaderCaption: 'Update Photo',
    UploadAvatar_Label_TakePhoto: 'Take Photo',
    UploadAvatar_Label_UploadFile: 'Upload File',
    UploadAvatar_Label_ZoomPhoto: 'Zoom Photo',
    UploadAvatar_Message_ErrorMultipleFiles: 'Please only drop a single file.',
    UploadAvatar_Message_InvalidFileType: 'Only image file types are allowed',
    UploadAvatar_Message_NoCamera:
        'You do not seem to have a camera attached to this device, or the webpage does not have access to the camera, please use the Upload Photo tab to add a photo.',
    UploadAvatar_Message_UnableToUploadMessage: 'Images must be in {0} format, and under {1}.',
    UploadAvatar_Message_UnableToUploadTitle: 'Unable to upload this file.',
    UploadAvatar_Message_UnknownError: 'An unknown error has occurred',

    // Flags:
    Label_Flags: 'Flags',
    // tslint:disable-next-line: object-literal-sort-keys
    Flags_Label_AccountHold: 'Account Hold',
    Flags_Label_IncidentHold: 'Incident Hold',
    Flags_Label_MedicalHold: 'Medical Hold',
    Flags_Label_Privacy: 'Privacy',
    Flags_Label_SituationResponseNotOkay: 'Not Okay',
    Flags_Label_SituationResponseOkay: 'Okay',
    Flags_Label_SituationResponseTooltip: 'Situation Response: {0}',
    Flags_Label_VisitorHold: 'Visitor Hold',

    // HeaderCell:
    HeaderCell_Label_NoOrder: 'Click to sort {0} {1}.',
    HeaderCell_Label_HasOrder: '{0} in {1} order.',
    HeaderCell_Label_Asc: 'ascending',
    HeaderCell_Label_Desc: 'descending',
};

export const strings = new LocalizedStrings({
    en: {
        ...english,
    },
    'en-US': {
        ...english,
    },
});
